import Vue from 'vue'
import App from './App.vue'
import element from 'element-ui'
import base from 'base-commons'
import './assets/css/style.scss'
import router from './router'
import http from './utils/http.js'
import api from './utils/api.js'
import components from './components/index'
import utils from './utils/index.js'
import 'amfe-flexible'

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$api = api
Vue.prototype.$utils = utils

for (let key in components) {
  Vue.component(key, components[key])
}
Vue.use(element, { size: 'medium' })
Vue.use(base)

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
